import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

import { AnnualSign } from '@/App/types';
import { BoarIcon } from '@/components/icons/annualSign/BoarIcon';
import { CatIcon } from '@/components/icons/annualSign/CatIcon';
import { DogIcon } from '@/components/icons/annualSign/DogIcon';
import { DragonIcon } from '@/components/icons/annualSign/DragonIcon';
import { GoatIcon } from '@/components/icons/annualSign/GoatIcon';
import { HorseIcon } from '@/components/icons/annualSign/HorseIcon';
import { MonkeyIcon } from '@/components/icons/annualSign/MonkeyIcon';
import { OxIcon } from '@/components/icons/annualSign/OxIcon';
import { RatIcon } from '@/components/icons/annualSign/RatIcon';
import { RoosterIcon } from '@/components/icons/annualSign/RoosterIcon';
import { SnakeIcon } from '@/components/icons/annualSign/SnakeIcon';
import { TigerIcon } from '@/components/icons/annualSign/TigerIcon';

interface AnnualSignIconProps extends SvgIconProps {
  annualSign: AnnualSign;
}

export const AnnualSignIcon: React.FC<AnnualSignIconProps> = (props) => {
  const { annualSign, ...rest } = props;

  switch (annualSign) {
    case AnnualSign.RAT: {
      return <RatIcon {...rest} />;
    }
    case AnnualSign.OX: {
      return <OxIcon {...rest} />;
    }
    case AnnualSign.TIGER: {
      return <TigerIcon {...rest} />;
    }
    case AnnualSign.CAT: {
      return <CatIcon {...rest} />;
    }
    case AnnualSign.DRAGON: {
      return <DragonIcon {...rest} />;
    }
    case AnnualSign.SNAKE: {
      return <SnakeIcon {...rest} />;
    }
    case AnnualSign.HORSE: {
      return <HorseIcon {...rest} />;
    }
    case AnnualSign.GOAT: {
      return <GoatIcon {...rest} />;
    }
    case AnnualSign.MONKEY: {
      return <MonkeyIcon {...rest} />;
    }
    case AnnualSign.ROOSTER: {
      return <RoosterIcon {...rest} />;
    }
    case AnnualSign.DOG: {
      return <DogIcon {...rest} />;
    }
    case AnnualSign.BOAR: {
      return <BoarIcon {...rest} />;
    }
    default: {
      return null;
    }
  }
};
